import React from "react";
import get from "lodash/get";

import "./entity-details.m.css";
import { ProfileImage } from "../profile-image";
import EntityShare from "../entity-share/entity-share";

export const ProfileTopPlace = ({ item, sketchesHost }) => {
  const profileImg = get(item, ["cover-image"], []);
  const profileUrl = sketchesHost + "/places/" + item?.slug;
  return (
    <div styleName="entity-details-header">
      <div styleName="profile-content">
        <div styleName="profile-content-left">
          <h1 styleName="headline">{item?.name}</h1>
          <p styleName="sub-headline">{item?.tagline}</p>
        </div>
        <div styleName="profile-content-rt">
          <EntityShare title={item?.name} url={profileUrl} />
        </div>
      </div>
      <div styleName="profile-image">
        <ProfileImage imageUrl={profileImg} defaultWidth="1110" isDetails={true} />
      </div>
      <div styleName="entity-meta-data">
        {item?.["place-type"] && (
          <div styleName="row-data">
            <span>Type:</span>
            {item?.["place-type"]}
          </div>
        )}
        {item?.location && (
          <div styleName="row-data">
            <span>Location:</span>
            {item?.["direction-map-url"] ? (
              <a href={item?.["direction-map-url"]} target="_blank" rel="noreferrer">
                {item?.location}
              </a>
            ) : (
              item?.location
            )}
          </div>
        )}
        {item?.["year-opened"] && (
          <div styleName="row-data">
            <span>Year Opened:</span>
            {item?.["year-opened"]}
          </div>
        )}
        {item?.["key-features"] && (
          <div styleName="row-data">
            <span>Key Feature(s):</span>
            {item?.["key-features"]}
          </div>
        )}
        {item?.website && (
          <div styleName="row-data">
            <span>Website:</span>
            <a href={item?.website} target="_blank" rel="noreferrer">
              {item?.website}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
